export const volumeLow = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 6.00033H4.66667L8 2.66699V13.3337L4.66667 10.0003H2V6.00033ZM11.06 8.00033L9.33333 6.27366L10.2733 5.33366L12 7.06033L13.7267 5.33366L14.6667 6.27366L12.94 8.00033L14.6667 9.72699L13.7267 10.667L12 8.94033L10.2733 10.667L9.33333 9.72699L11.06 8.00033Z" fill="white"/>
</svg>
`;
